import { Component, Input, OnInit } from "@angular/core";
import { CoreMenuItem } from "../../../../../@core/types";
import { UserDto } from "../../../../api/models/user-dto";
import { AuthService } from "../../../../util/service/auth.service";
import { CoreMenuService } from "../../../../../@core/components/core-menu/core-menu.service";

@Component({
    selector: "app-home-collapsible",
    templateUrl: "./home-collapsible.component.html",
    styleUrls: ["./home-collapsible.component.scss"],
    standalone: false
})
export class HomeCollapsibleComponent implements OnInit {
  @Input() item: CoreMenuItem;
  currentUser: UserDto;

  constructor(
    private _coreMenuService: CoreMenuService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
  }

  checkPermission(item: CoreMenuItem): boolean {
    return this._coreMenuService.checkPermission(item);
  }
}
